/**
 * Variables de entorno de la app.
 * Punto canónico: importar desde `@shared/utils/env` en código nuevo.
 */

import { getBuildTimeEnv } from './env.buildtime';

type EnvValue = string | undefined;

declare global {
  interface Window {
    __APP_CONFIG__?: Record<string, EnvValue>;
  }
}

const isUnsubstituted = (value: string): boolean => value.startsWith('${') && value.endsWith('}');

const readRuntime = (key: string): EnvValue => {
  if (typeof window === 'undefined') return undefined;
  const value = window.__APP_CONFIG__?.[key];
  if (typeof value !== 'string' || value.length === 0 || isUnsubstituted(value)) return undefined;
  return value;
};

const read = (key: string): EnvValue => readRuntime(key) ?? getBuildTimeEnv()[key];

export const getEnv = () => ({
  VITE_CAPTCHA_API_KEY: read('VITE_CAPTCHA_API_KEY'),
  VITE_ENABLE_TWO_FACTOR: read('VITE_ENABLE_TWO_FACTOR'),
  VITE_API_URL: read('VITE_API_URL'),
  VITE_APP_NAME: read('VITE_APP_NAME'),
  VITE_ENCRYPTION_KEY: read('VITE_ENCRYPTION_KEY'),
  VITE_IMAGE_SIZE_MAX_MB: read('VITE_IMAGE_SIZE_MAX_MB'),
  VITE_GOOGLE_MAPS_API: read('VITE_GOOGLE_MAPS_API'),
  VITE_TRANSFERS_REPORT_VERSION: read('VITE_TRANSFERS_REPORT_VERSION'),
  VITE_ENABLE_COOKIES: read('VITE_ENABLE_COOKIES'),
  VITE_PAYMENT_DAY: read('VITE_PAYMENT_DAY'),
  VITE_DEFAULT_TENANT: read('VITE_DEFAULT_TENANT'),
  VITE_CORRESPONDENT_BANK_ADMIN: read('VITE_CORRESPONDENT_BANK_ADMIN'),
  VITE_ENABLE_REMITTANCE_REPRINT: read('VITE_ENABLE_REMITTANCE_REPRINT'),
  VITE_ENABLE_CASHIN_DUPLICATE_OVERRIDE: read('VITE_ENABLE_CASHIN_DUPLICATE_OVERRIDE'),
  VITE_SEND_CORRELATION_ID: read('VITE_SEND_CORRELATION_ID'),
  VITE_ENABLE_CLIENT_ERROR_REPORTING: read('VITE_ENABLE_CLIENT_ERROR_REPORTING'),
  VITE_DEBUG: read('VITE_DEBUG') === 'true',
  VITE_ROOT_PATH: getBuildTimeEnv().VITE_ROOT_PATH,
  VITE_NODE_ENV: getBuildTimeEnv().VITE_NODE_ENV,
  VITE_APP_BUILD_TIME: getBuildTimeEnv().VITE_APP_BUILD_TIME,
});
